import type { GuideTourNotificationInteractionEvent } from '@/guide-tour/notifications/types'

/**
 * Seller entry point for Guide Tour analytics.
 *
 * The lib emits `GuideTourNotificationInteractionEvent` via `onInteraction`.
 * Map `event` → `segmentClient` here when the tracking plan is available in
 * `src/analytics/generated/segment.ts` — do not maintain a parallel schema.
 * Until then, `console.log('[Guide Tour]', event)` for local QA.
 *

 * | `action` | Typical source | Segment (when wired) |
 * | --- | --- | --- |
 * | `start` | Auto-start na rota | Guide Tour Viewed / `component_name: start` |
 * | `restart` + `componentName: 'restart'` | `GuideTourButton` | Guide Tour Clicked / `component_name: restart` |
 * | `restart` (sem `componentName`) | Painel / notificações | Guide Tour Clicked (definir no plano) |
 * | `tour-unavailable` | Nenhum target no 1º passo | Evento de falha (`tourId`, `tour`, `pathname`, `route`) |
 *
 * @see docs/guide-tour/implementation.md#analytics-and-tracking
 */
export const onGuideTourInteraction = (
  event: GuideTourNotificationInteractionEvent
): void => {
  console.log('[Guide Tour]', event)
}
